export {};

declare global {
    interface Math {
        nmod(n: number, d: number): number,
        clamp(n: number, lo: number, hi: number): number,
    }
}

Object.assign(Math, {
    nmod(n: number, d: number): number {
        return ((n % d) + d) % d;
    },

    clamp(n: number, lo: number, hi: number): number {
        return Math.max(lo, Math.min(n, hi));
    }
});

